import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronLeftBig = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.248 4.458a1.5 1.5 0 0 1-.197 2.112l-7.045 5.846 7.046 5.846a1.5 1.5 0 1 1-1.916 2.308l-7.691-6.38a2.3 2.3 0 0 1-.851-1.774c0-.704.328-1.34.85-1.773l.959 1.154-.958-1.154 7.691-6.381a1.5 1.5 0 0 1 2.112.196'
        fill='currentColor'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.248 4.458a1.5 1.5 0 0 1-.197 2.112l-7.045 5.846 7.046 5.846a1.5 1.5 0 1 1-1.916 2.308l-7.691-6.38a2.3 2.3 0 0 1-.851-1.774c0-.704.328-1.34.85-1.773l.959 1.154-.958-1.154 7.691-6.381a1.5 1.5 0 0 1 2.112.196'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
